/* TC60 mockup — lightweight motion. Respects prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals = document.querySelectorAll('.reveal');

  function revealAll() { reveals.forEach(function (el) { el.classList.add('in'); }); }

  /* --- scroll reveal (progressive enhancement) ---
     Only opt into hidden-then-animate if motion is allowed AND IO exists.
     Otherwise content stays visible (CSS default). A safety timer guarantees
     nothing ever stays hidden even if the observer misfires. */
  if (!reduce && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
    // safety net: if anything hasn't revealed within 3s, show it.
    setTimeout(function () {
      document.querySelectorAll('.reveal:not(.in)').forEach(function (el) { el.classList.add('in'); });
    }, 3000);
  } else {
    revealAll();
  }

  /* --- stat / count-up --- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (reduce) { el.textContent = target.toLocaleString(); return; }
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString();
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    counters.forEach(function (el) { cio.observe(el); });
  } else {
    counters.forEach(countUp);
  }

  /* --- persistent capture bar: show after scrolling past hero --- */
  var bar = document.getElementById('stickybar');
  if (bar) {
    var dismissed = false;
    var closeBtn = bar.querySelector('.close');
    if (closeBtn) closeBtn.addEventListener('click', function () { dismissed = true; bar.classList.remove('show'); });
    window.addEventListener('scroll', function () {
      if (dismissed) return;
      if (window.scrollY > window.innerHeight * 0.9) bar.classList.add('show');
      else bar.classList.remove('show');
    }, { passive: true });
  }

  /* --- fake form submit (mockup) --- */
  document.querySelectorAll('form[data-mock]').forEach(function (f) {
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var wrap = f.parentElement;
      var msg = document.createElement('p');
      msg.style.cssText = 'margin-top:14px;font-weight:700;color:#F3BF82;';
      msg.textContent = '✓ You’re on the list. Welcome to 60 years of TC.';
      f.style.display = 'none';
      wrap.appendChild(msg);
    });
  });

  /* --- decorate hero mosaic with duotone tiles --- */
  var mosaic = document.querySelector('.hero-mosaic');
  if (mosaic) {
    var grads = [
      'linear-gradient(135deg,#2B5561,#3D798A)',
      'linear-gradient(135deg,#BF6A15,#F3BF82)',
      'linear-gradient(135deg,#2F3335,#3D798A)',
      'linear-gradient(135deg,#D95004,#E29C56)',
      'linear-gradient(135deg,#3a4045,#747B7F)'
    ];
    for (var i = 0; i < 60; i++) {
      var s = document.createElement('span');
      s.style.backgroundImage = grads[i % grads.length];
      mosaic.appendChild(s);
    }
  }

  /* --- decorate face mosaics --- */
  document.querySelectorAll('.face-mosaic').forEach(function (fm) {
    var grads = ['#2B5561','#3D798A','#BF6A15','#E29C56','#747B7F','#D95004','#2F3335','#98A2A7'];
    for (var i = 0; i < 40; i++) {
      var t = document.createElement('div');
      t.className = 'tile';
      t.style.background = grads[i % grads.length];
      fm.appendChild(t);
    }
  });
})();
